import { Badge, type BadgeProps } from '@shopify/polaris';
import { classNames } from '~/presentation/common';
import { useMemo } from 'react';

export interface GBadgeProps {
  tone?: BadgeProps['tone'];
  size?: BadgeProps['size'];
  progress?: BadgeProps['progress'];
  toneAndProgressLabelOverride?: BadgeProps['toneAndProgressLabelOverride'];
  children?: string;
  type?: 'beta' | 'new' | 'enabled';
}

export const GBadge: React.FC<GBadgeProps> = ({ size = 'small', type, children, ...props }) => {
  const tone = useMemo(() => {
    switch (type) {
      case 'beta':
        return 'info';
      case 'new':
        return 'new';
      case 'enabled':
        return 'enabled';
      default:
        return props.tone ?? 'info';
    }
  }, [props.tone, type]);

  return (
    <div className={classNames('Polaris-GBadge', !children && 'Polaris-GBadge__OnlyIcon')}>
      <Badge size={size} tone={tone} {...props}>
        {children}
      </Badge>
    </div>
  );
};
